// extracted by mini-css-extract-plugin
export default {"display":"Workshops_display__A2t21","body":"Workshops_body__lOk0k","contentContainer":"Workshops_contentContainer__kkEQw","content":"Workshops_content__IG2qn"};